import { call, put, takeLatest } from "redux-saga/effects";
import { type HttpResponse } from "../../../Application/http/http";
import { EntityType } from "../../../common/types";
import HttpCodes from "../../../types/HttpCodes";
import { fetchEmbeddedVideo } from "../../services/assetsService";
import { type EmbeddedVideoPreview } from "../../types";
import { err, got, req, restricted } from "./embeddedVideoSlice";

function* handleResult(embeddedVideo: HttpResponse<EmbeddedVideoPreview>) {
  if (embeddedVideo.isSuccess) {
    const result: EmbeddedVideoPreview = {
      ...embeddedVideo.data!,
      type: EntityType.EmbeddedVideo,
    };
    yield put(got({ current: result }));
  } else if (embeddedVideo.code === HttpCodes.Forbidden || embeddedVideo.code === HttpCodes.NotFound) {
    yield put(restricted());
  } else {
    throw new Error(embeddedVideo.message);
  }
}

export function* handleFetchEmbeddedVideo(action: ReturnType<typeof req>) {
  try {
    const embeddedVideo: HttpResponse<EmbeddedVideoPreview> = yield call(fetchEmbeddedVideo, action.payload.id);
    yield* handleResult(embeddedVideo);
  } catch (error: any) {
    yield put(err({ errorMessage: error?.message }));
  }
}

export function* embeddedVideoWatcherSaga() {
  yield takeLatest(req.type, handleFetchEmbeddedVideo);
}
